import * as React from "react";
import { v4 } from "uuid";
import { DragDropContext, DropResult } from "react-beautiful-dnd";
import { CoughEventTypeDroppable, CorrectedArrayFieldProps } from "./CoughEventType";
import { useArrayField, ArrayFieldReturnPropParameters } from "informed";

interface CoughSettingsEventsProps {
}

export const CoughSettingsEvents = ({  }: CoughSettingsEventsProps) => {
    const { addWithInitialValue, fields, swap } = useArrayField({ field: "eventTypes" }) as ArrayFieldReturnPropParameters & { swap: (a: number, b: number) => void, remove: any };    // HACK: Types do not have swap or remove in this version of the typings

    const onDragEndInDelete = (result: DropResult) => {

        const sourceIndex = result.source.index;

        fields[sourceIndex].remove();
    };

    const onDragEnd = (result: DropResult) => {
        if (!result.destination) {
            return;
        }

        const sourceIndex = result.source.index;
        const destIndex = result.destination.index;

        if (result.destination.droppableId === "Delete") {
            return onDragEndInDelete(result);
        }


        swap(sourceIndex, destIndex);
    };

    return (
        <div className="panel panel-default">
            <div className="panel-heading">
                <h3 className="panel-title">Events</h3>
            </div>
            <div className="panel-body">
                <div className="row">
                    <div className="col-md-12">
                        <button className="btn btn-primary btn-outline pull-right" onClick={() => addWithInitialValue({ id: v4(), name: "temp", color: "#000000" })}>Add Event Type</button>
                    </div>
                </div>
                <div className="row">
                    <div className="pull-right col-md-12">
                        <DragDropContext onDragEnd={onDragEnd}>
                            <div className="row">
                                <CoughEventTypeDroppable eventTypes={fields as CorrectedArrayFieldProps[]} />
                            </div>
                        </DragDropContext>
                    </div>
                </div>
            </div>
        </div>
    );
}
